var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-8 space-y-2 max-w-7xl mx-auto"},[_c('pre',[_c('code',[_vm._v("\n"+_vm._s(JSON.stringify(_vm.data, null, 2))+"\n")]),_vm._v("\n")])])}
var staticRenderFns = []

export { render, staticRenderFns }